import {useEffect, useState} from 'react';
import cn from 'classnames';
import {motion} from 'framer-motion';
import CheckIcon from '@/_application/icons/check-icon';

interface FilterItemProps {
    label: string;
    status: boolean;
    onChange: (isSelected: boolean) => void;
    variant?: 'outline' | 'solid';
}

const FilterItem: React.FC<FilterItemProps> = ({label, status, onChange, variant = 'solid'}) => {
    const [isActive, setIsActive] = useState<boolean>();

    const selectItem = () => {
        onChange(!isActive);
        setIsActive(current => !current);
    };

    useEffect(() => {
        setIsActive(status);
    }, [status]);

    return (
        <motion.button
            onClick={selectItem}
            whileTap={{translateY: 2}}
            className={cn(
                'mt-3 flex h-[22px] w-auto shrink-0 content-center items-center justify-center gap-1 rounded-[50px] border px-2 py-1',
                {
                    'bg-KPZ_Blue-Dark': isActive && variant === 'solid',
                    'bg-white': !isActive,
                },
            )}>
            <p
                className={cn('text-xs font-bold', {
                    'text-white': isActive && variant === 'solid',
                    'text-KPZ_text_1st': !isActive,
                })}>
                {label}
            </p>
            {isActive && variant === 'outline' && (
                <div className="mx-1 h-3 w-3 rounded-[50px] bg-green-500">
                    <CheckIcon width={12} height={12} color={'#FFFFFF'} />
                </div>
            )}
        </motion.button>
    );
};

export default FilterItem;
